import axios from "axios";

export default {
  namespaced: true,

  state: {
    all: [],
  },

  actions: {
    index({ commit }) {
      return axios.get(process.env.VUE_APP_API_URL + 'settings')
        .then(({ data }) => {
          commit('setItems', [
            {
              name: 'Buisframe',
              price: data.pipe_frame_price || 0,
              selected: false,
              tooltip_key: 'tooltip_pipe_frame',
            },
            {
              name: 'Kruiwagen model',
              price: data.wheelbarrow_price || 0,
              selected: false,
              tooltip_key: 'tooltip_wheelbarrow',
            },
            {
              name: '12V dynamo 40A',
              price: data.dynamo_price || 0,
              selected: false,
              tooltip_key: 'tooltip_dynamo',
            },
            {
              name: 'Koeler',
              price: data.cooler_price || 0,
              selected: false,
              tooltip_key: 'tooltip_cooler',
            },
            {
              name: 'Dichte kast',
              price: data.closed_box_price || 0,
              selected: false,
              tooltip_key: 'tooltip_closed_cabin',
            },
          ]);
        });
    },
  },

  getters: {
    getAll(state) {
      return state.all;
    },
  },

  mutations: {
    setItems(state, array) {
      state.all = array;
    },

    setSelected(state, {index, bool}) {
      state.all[index].selected = bool;
    },
  },
}
